module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_8003.67a84096.png";